import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ConfidenceIndicator } from "@/components/trust/ConfidenceIndicator";

export function RootCauseConsolidation({ item, onCreateAction }) {
  return (
    <Card className="bg-[var(--oim-surface)] border-[var(--oim-border)]" data-testid={`root-cause-${item.root_cause.replace(/[^a-zA-Z]/g, "-")}`}>
      <CardContent className="pt-4 space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm font-heading font-bold text-[var(--oim-text)]">ROOT CAUSE — {item.root_cause}</span>
          <ConfidenceIndicator level={item.confidence} />
        </div>
        <div className="space-y-1.5">
          {item.consequences.map((c, i) => (
            <div key={i} className="flex items-center justify-between text-xs">
              <span className="text-[var(--oim-text-secondary)] font-heading">{c.domain}</span>
              {c.monetized === false ? (
                <span className="text-[10px] text-[var(--oim-text-dim)]">{c.caption || c.description}</span>
              ) : (
                <span className="font-mono-data text-[var(--oim-text)]">₹{Math.round(c.value).toLocaleString("en-IN")}/day</span>
              )}
            </div>
          ))}
        </div>
        <div className="flex items-center justify-between pt-2 border-t border-[var(--oim-border)] font-mono-data text-sm font-semibold">
          <span className="text-[var(--oim-text)]">Total economic consequence</span>
          <span className="text-[var(--oim-text)]">₹{Math.round(item.total_economic_consequence).toLocaleString("en-IN")}/day</span>
        </div>
        {item.has_safety_consequence && <div className="text-[10px] text-[var(--oim-text-dim)]">plus one safety consequence</div>}
        {item.statement && <div className="font-heading text-sm text-[var(--oim-text)] pt-1">{item.statement}</div>}
        {onCreateAction && (
          <Button
            size="sm"
            className="bg-[#00C853] text-black hover:bg-[#00a844] font-semibold rounded-full text-xs"
            data-testid={`create-action-${item.finding_ids[0]}-button`}
            onClick={() => onCreateAction(item)}
          >
            Create action
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
